import { type Breadcrumb } from "~/components/molecules/Breadcrumbs";
import Footer from "~/components/organisms/Footer";
import Header from "~/components/organisms/Header";

export default function PageContainer({
    className,
    children,
    breadcrumbs,
}: {
    children: React.ReactNode;
    className?: string;
    breadcrumbs?: Breadcrumb[];
}) {
    return (
        <div className={className}>
            <Header breadcrumbs={breadcrumbs} />
            <main className="relative h-full">{children}</main>
            <Footer />
        </div>
    );
}
